export const perPageSelectOptions: string[] = ['10', '25', '50', '75', '100']
